const MAX_HISTORY_ENTRIES = 100;

/**
 * Undo/redo stack over element arrays. Entries share unchanged element object
 * references (elements are treated as immutable at commit boundaries), so a
 * history entry costs one array of references — no serialization, no clones.
 * @param {Array<object>} initialElements
 * @returns {object}
 */
export const createCanvasHistory = (initialElements) => {
  let past = [];
  let future = [];
  let present = initialElements;

  const push = (nextElements) => {
    past.push(present);
    if (past.length > MAX_HISTORY_ENTRIES) past.shift();
    future = [];
    present = nextElements;
  };

  const undo = () => {
    if (!past.length) return null;
    future.unshift(present);
    present = past.pop();
    return present;
  };

  const redo = () => {
    if (!future.length) return null;
    past.push(present);
    present = future.shift();
    return present;
  };

  const reset = (nextElements) => {
    past = [];
    future = [];
    present = nextElements;
  };

  return {
    canRedo: () => future.length > 0,
    canUndo: () => past.length > 0,
    getPresent: () => present,
    push,
    redo,
    reset,
    undo,
  };
};
